import React, { useState } from "react";
import { FaCheck } from "react-icons/fa";
import apiClient from "../../api/apiClient";
import { toast } from "react-toastify";
import { useEffect } from "react";
import useApi from "../../hooks/useApi";
export const AdvertisersSetting = () => {
  const initialData = {
    app_notification: false,
    email_notification: false,
    push_notification: false,
    email_report: false,
    primary_color: "",
    secondery_color: "",
  };

  const [submitData, setSubmitData] = useState(initialData);
  const handleChange = (key, value) => {
    setSubmitData({
      ...submitData,
      [key]: value,
    });
  };
  const { request, loading, error } = useApi((submitData) =>
    apiClient.put("/advertiserSetting", submitData)
  );
  useEffect(() => {
    const fetchData = async () => {
      const response = await apiClient.get("/advertiserSetting");
      const data = response.data;
      setSubmitData(data);
    };

    fetchData();
  }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await request(submitData);
    if (result.status === 200) {
      toast.success("Account Succesfully Created");
    } else {
      toast.error("Error");
    }
  };
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="site-content h-100">
          <div className="p-4">
            <div className="site-content-body">
              <section className="notification-sec mt-4">
                <div className="container">
                  <div className="row notification-main d-flex justify-content-between">
                    <div className="col-lg-5 pe-md-4">
                      <h3 className="notify-head blue-clr fs-3 fw-bold lh-base position-relative">
                        Notifications
                      </h3>
                      <div className="mt-5">
                        <div className="mt-5">
                          <div className="toggle d-flex justify-content-between align-items-center">
                            <label
                              htmlFor="a_notification"
                              className="blue-clr fs-4 fw-normal lh-base"
                            >
                              App Notifications
                            </label>
                            <input
                              checked={submitData?.app_notification}
                              type="checkbox"
                              id="a_notification"
                              className="notify-check"
                              onClick={(e) =>
                                handleChange(
                                  "app_notification",
                                  e.target.checked
                                )
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="mt-3">
                        <div className="toggle d-flex justify-content-between align-items-center">
                          <label
                            htmlFor="e_notification"
                            className="blue-clr fs-4 fw-normal lh-base"
                          >
                            Email Notifications
                          </label>
                          <input
                            checked={submitData?.email_notification}
                            type="checkbox"
                            id="e_notification"
                            className="notify-check fs-4 fw-normal lh-base"
                            onClick={(e) =>
                              handleChange(
                                "email_notification",
                                e.target.checked
                              )
                            }
                          />
                        </div>
                      </div>
                      <div className="mt-3">
                        <div className="toggle d-flex justify-content-between align-items-center">
                          <label
                            htmlFor="p_notification"
                            className="blue-clr fs-4 fw-normal lh-base"
                          >
                            Push Notifications
                          </label>
                          <input
                            checked={submitData?.push_notification}
                            type="checkbox"
                            id="p_notification"
                            className="notify-check"
                            onClick={(e) =>
                              handleChange(
                                "push_notification",
                                e.target.checked
                              )
                            }
                          />
                        </div>
                        <div className="mt-3">
                          <div className="toggle d-flex justify-content-between align-items-center">
                            <label
                              htmlFor="e_report"
                              className="blue-clr fs-4 fw-normal lh-base"
                            >
                              Email Reports
                            </label>
                            <input
                              checked={submitData?.email_report}
                              type="checkbox"
                              id="e_report"
                              className="notify-check"
                              onClick={(e) =>
                                handleChange("email_report", e.target.checked)
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-5 ps-lg-4 mt-5 mt-md-0">
                      <div>
                        <h3 className="notify-head blue-clr fs-3 fw-bold lh-base position-relative">
                          Account
                        </h3>
                      </div>
                      <div className="row mt-4">
                        <div className="mt-2 report-problem py-1 px-2 rounded">
                          <a
                            href="#"
                            className="fs-5 lh-base fw-normal text-white"
                          >
                            Report problem with account
                          </a>
                        </div>
                        <div className="mt-4 report-problem py-1 px-2 rounded">
                          <a
                            href="#"
                            className="fs-5 lh-base fw-normal text-white"
                          >
                            Report problem with App
                          </a>
                        </div>
                      </div>
                      <div className="mt-4">
                        <h3 className="notify-head blue-clr fs-3 fw-bold lh-base position-relative">
                          App Design
                        </h3>
                        <div className="primary d-flex align-items-center mt-4">
                          <p className="blue-clr fs-5 w-50">Primary color:</p>
                          <input
                            type="color"
                            defaultValue="#FF7824"
                            className="style1 p-0"
                            id="eye-dr"
                          />
                          <label htmlFor="eye-dr">
                            <i className="bi bi-eyedropper fs-4 ms-1" />
                          </label>
                        </div>
                        <div className="primary d-flex align-items-center mt-4">
                          <p className="blue-clr fs-5 w-50">Secondary color:</p>
                          <input
                            type="color"
                            defaultValue="#FFFFFF"
                            className="style1 p-0"
                            id="eye-dr2"
                          />
                          <label htmlFor="eye-dr2">
                            <i className="bi bi-eyedropper fs-4 ms-1" />
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col text-center mt-5 save-main">
                      <button
                        type="submit"
                        className="btn blue-clr fs-4 lh-base fw-normal"
                      >
                        <span className="pe-2">Save Changes</span>
                        <FaCheck />
                        {/* <i className="fa-solid fa-check ms-3" /> */}
                      </button>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};
